<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8828 13.5724H1.11715C0.896663 13.5724 0.69293 13.4542 0.582684 13.2628C0.472439 13.0723 0.472439 12.8368 0.582684 12.6463L7.46465 0.723918C7.68514 0.342027 8.31398 0.342027 8.53447 0.723918L15.4173 12.6463C15.5276 12.8368 15.5276 13.0723 15.4173 13.2628C15.3071 13.4542 15.1033 13.5724 14.8828 13.5724ZM2.18698 12.3376H13.813L8 2.26824L2.18698 12.3376Z"
      :fill="iconColor"
    />
    <path
      d="M8.61737 11.1028C8.61737 11.4441 8.33955 11.7202 7.99999 11.7202C7.65867 11.7202 7.38262 11.4441 7.38262 11.1028C7.38262 10.7624 7.65867 10.4854 7.99999 10.4854C8.34043 10.4854 8.61737 10.7624 8.61737 11.1028Z"
      :fill="iconColor"
    />
    <path
      d="M7.99999 9.8681C7.65867 9.8681 7.38262 9.59205 7.38262 9.25073V5.35509C7.38262 5.01377 7.65867 4.73772 7.99999 4.73772C8.34131 4.73772 8.61737 5.01377 8.61737 5.35509V9.24985C8.61737 9.59117 8.34131 9.8681 7.99999 9.8681Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconWarning",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
